import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-login\"><defs><style></style></defs><path d=\"M409.003 469.333L300.8 361.131l60.33-60.331L572.33 512l-211.2 211.2-60.33-60.33 108.203-108.203H128v-85.334h281.003zM469.333 128h341.334C857.6 128 896 166.4 896 213.333v597.334C896 857.6 857.6 896 810.667 896H469.333v-85.333h341.334V213.333H469.333V128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol